//WE.Flow.Html.Models.SelectedProduct

export class SelectedProduct {
    id: string = "";
    payload: string = "";
}
